export const ArticleList = [
  {
    date: "JUNE 26, 2023",
    title: "Salmon with Basil Sauce and Tomato Salad",
    image:
      "https://pinchofyum.com/wp-content/uploads/Salmon-with-Basil-Sauce-Square-1-300x300.png",
    content:
      "We’re making a summery salmon with a beautiful, big-flavored basil sauce that is so good, you’re going to want to just drink it. Perfectly-spiced, fresh, and a dinner for everyone!",
  },
  {
    date: "JUNE 23, 2023",
    title: "14 Things I Bought For Summer That I Can’t Live Without",
    image:
      "https://pinchofyum.com/cdn-cgi/image/width=360,height=360,fit=crop/wp-content/uploads/July-Coffee-Date-1-6.jpg",
    content:
      "Let’s go on a summer shopping spree! These are the 14 things I now cannot live without for summer and I’m excited to tell you about them.",
  },
  {
    date: "JUNE 19, 2023",
    title: "Chicken Teriyaki Burgers with Sesame Slaw",
    image:
      "https://pinchofyum.com/wp-content/uploads/Teriyaki-Burgers-9-1-300x300.jpg",
    content:
      "These Chicken Teriyaki Burgers are amazingly simple while also being ridiculously delicious. Caramelized burgers that are fried up in minutes, a pile of sesame slaw on top, and a perfectly toasted bun. YUM.",
  },
];

